export function register({ payload, params }) {
  return {
    url: `/api/${params.group}`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }
}
